var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511 511",
    style: {
      enableBackground: "new 0 0 511 511"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M151.5,264c-4.142,0-7.5,3.358-7.5,7.5v72c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-72 C159,267.358,155.642,264,151.5,264z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M215.5,80h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,80,215.5,80z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M215.5,104h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,104,215.5,104z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M215.5,128h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,128,215.5,128z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M215.5,160h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,160,215.5,160z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M215.5,184h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,184,215.5,184z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M215.5,208h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,208,215.5,208z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M215.5,232h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,232,215.5,232z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M215.5,264h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,264,215.5,264z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M215.5,288h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,288,215.5,288z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M215.5,312h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,312,215.5,312z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M215.5,336h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,336,215.5,336z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M215.5,368h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,368,215.5,368z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M215.5,392h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,392,215.5,392z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M215.5,416h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,416,215.5,416z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M215.5,440h-16c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5h16c4.142,0,7.5-3.358,7.5-7.5S219.642,440,215.5,440z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M311.5,328c-21.78,0-39.5,17.72-39.5,39.5v48c0,21.78,17.72,39.5,39.5,39.5s39.5-17.72,39.5-39.5v-48 C351,345.72,333.28,328,311.5,328z M336,415.5c0,13.509-10.991,24.5-24.5,24.5S287,429.009,287,415.5v-48 c0-13.509,10.991-24.5,24.5-24.5s24.5,10.991,24.5,24.5V415.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    d: "M479.5,0h-448C14.131,0,0,14.131,0,31.5v104C0,152.869,14.131,167,31.5,167H88v304.5c0,21.78,17.72,39.5,39.5,39.5h256 c21.78,0,39.5-17.72,39.5-39.5V167h56.5c17.369,0,31.5-14.131,31.5-31.5v-104C511,14.131,496.869,0,479.5,0z M383.5,496h-256 c-13.509,0-24.5-10.991-24.5-24.5V159.529c0-0.01,0.001-0.02,0.001-0.029S103,159.48,103,159.471V71h41v168.5 c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5V71h40.5h16h58.097C272.57,73.638,272,76.503,272,79.5v48 c0,12.958,10.542,23.5,23.5,23.5h32c12.958,0,23.5-10.542,23.5-23.5v-48c0-2.997-0.57-5.862-1.597-8.5H408v88.452 c0,0.016-0.002,0.032-0.002,0.048s0.002,0.032,0.002,0.048V471.5C408,485.009,397.009,496,383.5,496z M311.5,87 c4.142,0,7.5-3.358,7.5-7.5V71h8.5c4.687,0,8.5,3.813,8.5,8.5V96h-49V79.5c0-4.687,3.813-8.5,8.5-8.5h8.5v8.5 C304,83.642,307.358,87,311.5,87z M311.5,120c-4.142,0-7.5,3.358-7.5,7.5v8.5h-8.5c-4.687,0-8.5-3.813-8.5-8.5V111h49v16.5 c0,4.687-3.813,8.5-8.5,8.5H319v-8.5C319,123.358,315.642,120,311.5,120z M496,135.5c0,9.098-7.402,16.5-16.5,16.5H423V71h24.5 c4.142,0,7.5-3.358,7.5-7.5s-3.358-7.5-7.5-7.5h-384c-4.142,0-7.5,3.358-7.5,7.5s3.358,7.5,7.5,7.5H88v81H31.5 c-9.098,0-16.5-7.402-16.5-16.5v-104C15,22.402,22.402,15,31.5,15h448c9.098,0,16.5,7.402,16.5,16.5V135.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceive);
export default __webpack_public_path__ + "static/media/receive.17a8a13c53b1bc6a0e989da37eb0c452.svg";
export { ForwardRef as ReactComponent };